import React from 'react';

import {
    BrowserRouter,
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Resume from './screens/Resume';
import Landing from './screens/Landing';
import Showcase from './screens/Showcase';
import Faith from './screens/Faith';

import './styles/globals.scss';

function App() {
    const location = useLocation();

    return <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="resume" element={<Resume />} />
                <Route path="showcase" element={<Showcase />} />
                <Route path="contact" element={<Resume />} />
                <Route path="faith" element={<Faith />} />
            </Routes>
        </CSSTransition>
    </TransitionGroup>;
}

const Root = () => <BrowserRouter><App /></BrowserRouter>;

export default Root;
